module.exports = "<div data-bind=\"visible: visible\"> <div data-bind=\"if: visible\" class=confirm-refer> <header class=confirm-header> <span data-bind=\"text: title\"></span> </header> <main class=confirm-main class=u-form-group> <textarea class=u-form-control data-bind=\"value: reason, attr: {maxlength: maxlength}\">\n      </textarea> </main> <footer class=confirm-footer> <button data-bind=\"click: onCancel\" class=\"u-msg-cancel u-button\">取消</button> <button data-bind=\"click: onOK\" class=\"u-msg-ok u-button\">确定</button> </footer> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/confirm-with-reason-select/index.html
// module id = 437
// module chunks = 144